export const getGameFee = (zoomerAmount: string): string => {
    const zoomerAmountNum = parseInt(zoomerAmount);
    const rouletteFee = (
        zoomerAmountNum > 2 ? '0.4' :
            zoomerAmountNum > 1 ? '0.6' :
                zoomerAmountNum > 0 ? '0.8' :
                    '1'
    );
    return rouletteFee;
}